const socialMediaData: {[key: string]: any} = {
  pinterest: {
    id: "pinterest",
    label: "Pinterest",
    icon: "bi bi-pinterest",
    color: "#BD081C",
  },
  snapchat: {
    id: "snapchat",
    label: "Snapchat",
    icon: "bi bi-snapchat",
    color: "#FFFC00",
  },
  google: {
    id: "google",
    label: "Google",
    icon: "bi bi-google",
    color: "#4285F4",
  },
  tiktok: {
    id: "tiktok",
    label: "TikTok",
    icon: "bi bi-tiktok",
    color: "#000000",
  },
  meta: {
    id: "meta",
    label: "Meta",
    icon: "bi bi-meta",
    color: "#1877F2",
  },
  linkedin: {
    id: "linkedin",
    label: "LinkedIn",
    icon: "bi bi-linkedin",
    color: "#0077B5",
  },
  // Connected TV. Bootstrap Icons has no Vibe glyph, and a television reads correctly next to
  // the social brands — on this network the medium is the distinguishing thing, not the vendor.
  vibe: {
    id: "vibe",
    label: "Vibe",
    icon: "bi bi-tv",
    color: "#6C2BD9",
  },
};

export default socialMediaData;
